import { forEach, isEmpty, isObject } from 'lodash'
import xss from 'xss'
import moment from 'moment'
import colors from 'vuetify/lib/util/colors'

export default {
  computed: {
    _colorList () {
      let colorlist = []
      forEach(colors, color => {
        forEach(color, (hex, hexName) => {
          if (['base', 'dark'].includes(hexName.substring(0, 4))) colorlist.push(hex)
        })
      })
      return colorlist
    }
  },
  methods: {
    _$ (val, precision = 2) {
      var formattedValue = (val / 100).toFixed(precision)
      return '$' + formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    _initials (name) {
      let f = ''
      let l = ''
      let firstName = ''
      let lastName = ''
      if (!name) return '--'

      if (name.constructor !== Array) {
        name = name.replace(/\s\s+/gi, ' ').split(' ')
      }

      if (name.length > 1) {
        firstName = name[0]
        lastName = name[1]
      } else {
        firstName = name[0]
      }

      if (firstName) {
        if (firstName) f = firstName.charAt(0).toUpperCase() 
        if (lastName) {
          l = lastName.charAt(0).toUpperCase()
        } else {
          l = firstName.substring(1, 2).toLowerCase()
        }
        return f + l
      } else {
        return '--'
      }
    },
    _randomMaterialColor () {
      return this._colorList[Math.floor(Math.random() * this._colorList.length)]
    },
    _emailToColor(email) {
      // https://stackoverflow.com/questions/43193341/how-to-generate-random-pastel-or-brighter-color-in-javascript
        let first = (email.toLowerCase().charCodeAt(0) - 96)
        let second = (email.toLowerCase().charCodeAt(2) - 96)
        let hue = Math.floor( (first / 26) * 341) - 13 + (second / 2); // between 0 and 340
        let saturation = 100;
        let lightness = 45;
        
        // color adjustment:
        if(hue > 215 && hue < 265) {
          const gain = 20;
          let blueness = 1 - Math.abs( hue-240)/25;
          let change  = Math.floor( gain * blueness);
          lightness += change;
          saturation -= change;
        }
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
    _templateLiteralString (str) {
      if (!str) return ''
      str = str.toString()
      var $ = this // eslint-disable-line no-unused-vars
      var interpolate = (str) => {
        var interpolate = () => {
          return str.replace(/{{([^{}]*)}}/g, (a, b) => {
            try {
              return eval(`${b}`) // eslint-disable-line no-eval
            } catch (e) {
              console.error(e);
              return 'undefined'
            }
          })
        }
        return interpolate
      }
      return interpolate(str)()
    },
    _durationText (duration) {
      if (duration <= 24) {
        let hours = moment.duration(Number(duration), 'hours').asHours()
        return `${hours} hours`
      } else {
        let days = moment.duration(Number(duration), 'hours').asDays()
        return `${days} days`
      }
    },
    _timeAgo (date) {
      let ago = moment().diff(moment(date))

      if (ago < 1000 * 60) return 'a few seconds ago'
      if (ago < 1000 * 60 * 60) return `${Math.floor(ago / 1000 / 60)} minute${Math.floor(ago / 1000 / 60) > 1 ? 's' : ''} ago`
      if (ago < 1000 * 60 * 60 * 24) return `${Math.floor(ago / 1000 / 60 / 60)} hour${Math.floor(ago / 1000 / 60 / 60) > 1 ? 's' : ''} ago`
      if (ago < 1000 * 60 * 60 * 24 * 7) return `${Math.floor(ago / 1000 / 60 / 60 / 24)} day${Math.floor(ago / 1000 / 60 / 60 / 24) > 1 ? 's' : ''} ago`
      return `${Math.floor(ago / 1000 / 60 / 60 / 24 / 7)} week${Math.floor(ago / 1000 / 60 / 60 / 24 / 7) > 1 ? 's' : ''} ago`
    },
    _formatDate (date) {
      // if (!date) return ''
      return moment(date).format('DD-MMM-YYYY')
    },
    _formatDateShort (date) {
      // if (!date) return ''
      return moment(date).format('DD-MMM-YY')
    },
    _formatDateTime (date) {
      return moment(date).format('DD-MMM-YYYY HH:mm')
    },
    _formatValue (value, format) {
      if (value === 'nil') return value
      // var parseNumber = () => { return Math.round((parseFloat(value || 0) + 0.00001) * 100) / 100 }
      switch (format) {
        case 'text': return value
        // case 'number': return parseNumber()
        case 'number': return parseFloat(value || 0)
        case 'currency': return this._$(value)
        // case 'percent': return `${parseNumber()}%`
        case 'percent': return `${parseFloat((value * 100) || 0)}%`
        case 'date': return value ? this._formatDate(value) : ''
        case 'boolean':
          switch (value) {
            case true: return 'Yes'
            case false: return 'No'
            default: return value
          }
        default: return value
      }
    },
    _capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    _fileSize (size, si = true) {
      var thresh = si ? 1000 : 1024
      if (Math.abs(size) < thresh) {
        return size + ' B'
      }
      var units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
      var u = -1
      do {
        size /= thresh
        ++u
      } while (Math.abs(size) >= thresh && u < units.length - 1)
      return size.toFixed(1) + ' ' + units[u]
    },
    _shortAddress (address) {
      address = address || {}
      return `<span class="">${xss(address.streetNum)} ${xss(address.streetName)}</span>, <span>${xss(address.city)}</span> `
    },
    _xss (text) {
      return xss(text)
    },
    _formatLineBreaks (text) {
      if (!text) return ''
      text = text.toString()
      return text.replace(/\n/g, '<br />')
    },
    _objectToArrayAplha (o, key) {
      if (!isObject(o)) return console.error('heleprs => _objectToArrayAplha: \n must provide valid object to be sorted')
      if (typeof key !== 'string') return console.error('heleprs => _objectToArrayAplha: \n must provide key as string')
      if (isEmpty(o)) return []
      var arr = Object.keys(o).map(k => { return { ...o[k], id: k } })
      return arr.sort((a, b) => { return a[key].localeCompare(b[key]) })
    },
    _sortObject (data, index = 'index') {
      if (isEmpty(data)) return []

      var internalData = Object.assign({}, data)
      var arr = []

      forEach(internalData, (detail, id) => {
        // console.log(id)
        if (typeof detail !== 'undefined') {
          detail.id = id
          arr.push(detail)
        }
      })

      var compare = (a, b) => {
        if (typeof index === 'string') {
          if (a[index] < b[index]) return -1
          if (a[index] > b[index]) return 1
        } else if (typeof index === 'function') {
          if (index(a) < index(b)) return -1
          if (index(a) > index(b)) return 1
        }
        return 0
      }
      return arr.sort(compare)
    },
    _unSortObject (array) {
      var object = {}
      forEach(array, item => {
        object[item.id] = item
      })
      return object
    },
    _arrayMove (arr, oldIndex, newIndex, indexItems) {
      while (oldIndex < 0) {
        oldIndex += arr.length
      }
      while (newIndex < 0) {
        newIndex += arr.length
      }
      if (newIndex >= arr.length) {
        var k = newIndex - arr.length + 1
        while (k--) {
          arr.push(undefined)
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])

      if (indexItems) {
        arr.map((x, i) => { x.index = i })
      }

      return arr // for testing purposes
    },
    _removeUndefined (obj) {
      return JSON.parse(JSON.stringify(obj, function (k, v) {
        if (v === undefined) { return null }
        if (v === 'NaN') { return null }
        return v
      }))
    },
    _hostFromUrl (url) {
      if (!url) return ''
      var pathArray = url.split('/')
      var protocol = pathArray[0]
      var host = pathArray[2]
      return protocol + '//' + host
    },
    _treeViewObject (o, p = '') {
      let arr = []
      forEach(o, (v, k) => {
        let path = `${p}${p ? '.' : ''}${k}`
        if (typeof v === 'object') {
          arr.push({ id: k, name: k, value: v, path, html: `<span class="font-weight-bold">${k}</span>`, children: this._treeViewObject(v, path) })
        } else {
          arr.push({ id: k, name: k, value: v, path, html: ` <span class="font-weight-bold">${k}</span><span class="">:   ${v}</span>` })
        }
      })
      return arr
    },
    _exportToJsonFile (jsonData, name = 'data') {
      name = name.split('.')[0]
      let dataStr = JSON.stringify(jsonData)
      let dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr)

      let exportFileDefaultName = `${name}.json`

      let linkElement = document.createElement('a')
      linkElement.setAttribute('href', dataUri)
      linkElement.setAttribute('download', exportFileDefaultName)
      linkElement.click()
    },
    _exportToCsv(data, filename) {
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", filename);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
    _importFromJsonFile (file) {
      return new Promise((resolve) => {
        var fr = new FileReader()
        fr.onload = receivedText
        fr.readAsText(file.file)

        function receivedText (e) {
          let lines = e.target.result
          var newArr = JSON.parse(lines)
          resolve(newArr)
        }
      })
    },
    _calculateAge (birthDate, queryDate) {
      queryDate = moment(queryDate);
      birthDate = moment(birthDate);
      let ageYears = queryDate.diff(birthDate, 'years')
      return { 
        years: ageYears, 
        months: queryDate.diff(moment(birthDate).add(ageYears, 'years'), 'months') 
      }
    },
    _getThumbSrc (src) {
      try {
        let urlParts = src.split('%2F')
        let filePartIndex = urlParts.length - 1
        let filePart = `thumb_${urlParts[filePartIndex]}`
        urlParts[filePartIndex] = filePart
        return urlParts.join('%2F')
      } catch (error) {
        return null
      }
    },
   _stringUndefined (obj) {
      return JSON.parse(JSON.stringify(obj, (k, v) => {
         if (v === undefined) { return 'undefined' }
         if (v === 'NaN') { return 'NaN' }
         return v
      }));
    },
    _querySnapshotToArray (querySnapshot){
      if (!querySnapshot) return [];
      return querySnapshot.docs.map((d) => ( { ...d.data() || {}, id: d.id } ));
    },
    _sentenceCase (s) {
      const rg = /(^\w{1}|\.\s*\w{1})/gi
      return s.replace(rg, s => s.toUpperCase())
    },
  }
}
